import styled, { css } from 'styled-components';

export const HeaderIconContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TextAndArrowIconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 24px;
  ${(props) =>
    props.isSelected &&
    css`
      font-weight: bold;
    `}
`;

export const NavItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
